import { Component, inject } from '@angular/core';
import {
	AufgabeLfprKostenfreiGrund,
	AufgabeLfprKostenTaetigkeit,
	AufgabeLfprKostenTraeger,
	AufgabenTyp,
} from '@schir-int-client/aufgabe-shared';
import { CreateAufgabeFormService } from '../../../create-aufgabe-dialog/create-aufgabe.formservice';

@Component({
	selector: 'schir-int-client-aufgabe-lfpr-kosten-editor',
	templateUrl: './aufgabe-lfpr-kosten-editor.component.html',
	styleUrls: ['./aufgabe-lfpr-kosten-editor.component.scss'],
	standalone: false,
})
export class AufgabeLfprKostenEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	readonly kostenTaetigkeit = AufgabeLfprKostenTaetigkeit;
	readonly traeger = AufgabeLfprKostenTraeger;
	readonly grund = AufgabeLfprKostenfreiGrund;

	protected readonly formGroup = this.formService.form.controls.LFPR_KOSTEN;
	protected readonly bodyControls = this.formGroup.controls.body.controls;
	protected readonly AufgabenTyp = AufgabenTyp;
}
